"use client";

import { c as _c } from "react/compiler-runtime";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
export function BlogContent(t0) {
  const $ = _c(4);
  const {
    content
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [remarkGfm];
    t2 = [rehypeRaw];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== content) {
    t3 = <div className="prose prose-invert max-w-none prose-headings:text-foreground prose-headings:font-semibold prose-p:text-muted-foreground prose-a:text-accent prose-a:no-underline hover:prose-a:underline prose-strong:text-foreground prose-code:text-accent prose-code:bg-secondary prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded prose-code:text-sm prose-code:before:content-none prose-code:after:content-none prose-pre:bg-card prose-pre:border prose-pre:border-border prose-pre:rounded-xl prose-img:rounded-xl prose-img:border prose-img:border-border prose-blockquote:border-accent prose-blockquote:text-muted-foreground prose-hr:border-border prose-th:text-foreground prose-td:text-muted-foreground prose-li:text-muted-foreground"><ReactMarkdown remarkPlugins={t1} rehypePlugins={t2}>{content}</ReactMarkdown></div>;
    $[2] = content;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}